import React,{useState, useEffect} from 'react'
import api from '../../../api/api';

const JobPendingList = () => {

  const [pendingList, setPendingList] = useState([])


   useEffect(() => {
     api.get('/services/joborders/?status=pending')
     .then(response=> {
      // console.log(response.data)
      setPendingList(response.data)
     }).catch(error=> {
      console.log(error)
     })
   }, [])


  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Job Pending List
      </h1>
      <div className="">
        <img
          src="../../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>
      {/*  table */}
      <div className="mt-3 w-full md:px-10">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="overflow-hidden">
                <table className="border-primary-blue min-w-full border-2 text-center">
                  <thead className="bg-primary-red border-primary-blue border-2">
                    <tr>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        SN.
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        J.No
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Date
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Company Name
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Job Details
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Client/User Name
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Total Amount
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Status
                      </th>
                      {/* <th
                      scope="col"
                      className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                    >
                      Reason
                    </th> */}
                    </tr>
                  </thead>
                  <tbody className="font-Acme">
                    {pendingList.map((item, i) => {
                      return (
                        <tr className="border-b bg-white">
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {i + 1}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {item.id}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {item.date}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {item.company_name}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {item.job_order_details[0].details}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                            {item.contact_person_name}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                            {item.job_order_details[0].amount}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 py-2 px-4 text-xs text-white">
                            <p className="text-black text-base">
                              {item.status}
                            </p>
                          </td>
                          {/* <td className="border-primary-blue w-[400px] whitespace-nowrap border-2 py-2 px-4 text-xs">
                            {item.status ==="approved" ?
                             <>
                              <button className="bg-primary-green rounded-3xl p-2"
                                onClick={(e)=> handlePatch(e, "pending", item.id)}
                              >Pending</button>

                              <button className="bg-primary-green rounded-3xl p-2"
                                onClick={(e)=> handlePatch(e, "working", item.id)}
                              >Working</button>
                             </>:(item.status === "pending")? <>
                                 <button className="bg-primary-green rounded-3xl p-2"
                                 onClick={(e)=> handlePatch(e, "approved", item.id)}
                                 >Approved</button>

                                 <button className="bg-primary-green rounded-3xl p-2"
                                 onClick={(e)=> handlePatch(e, "working", item.id)}
                                 >Working</button>
                              </>:(item.status === "working") && <>
                                  <button className="bg-primary-green rounded-3xl p-2"
                                  onClick={(e)=> handlePatch(e, "pending", item.id)}
                                  >Pending</button>
                                  <button className="bg-primary-green rounded-3xl p-2"
                                  onClick={(e)=> handlePatch(e, "approved", item.id)}
                                  >Approved</button>
                              </>
                                             
                            }
                        </td> */}
                        </tr>
                      );
                    })}

                    {/* <tr className="border-b bg-white">
                    <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                      1
                    </td>
                    <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                      1
                    </td>
                    <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                      2078/1/1
                    </td>
                    <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                      company
                    </td>
                    <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                      job order
                    </td>
                    <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                      Bimal dangi
                    </td>
                    <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                      10000
                    </td>
                    <td className="border-primary-blue whitespace-nowrap border-2 py-2 px-4 text-xs text-white">
                      <p className="bg-primary-green rounded-3xl p-2">
                        Pending
                      </p>
                    </td>
                    <td className="border-primary-blue w-[400px] whitespace-nowrap border-2 py-2 px-4 text-xs">
                      Reason
                    </td>
                  </tr> */}
                  </tbody>
                </table>
                <div className="mt-5 flex items-center justify-end gap-10">
                  <div className="bg-primary-green font-Berkshire rounded-md px-5 py-3 font-bold text-white">
                    <a href="">Print List</a>
                  </div>
                  <div className="bg-primary-blue rounded-md px-5 py-3 font-bold text-white">
                    <a href="">View More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobPendingList;
